require('./brokerMarketsPulseDetailsView.scss');

const PropTypes = require('prop-types');

const React = require('react');
const { connect } = require('react-redux');
const { formatText, FormattedText, getFinalTitle } = require('core/i18n').i18n;
//@commons
const { OKHeaderSubPage } = require('commonsComponents/OKHeaderSubPage');
const { OKCover } = require('commonsComponents/OKCover');
const { OKLink } = require('commonsComponents/OKLink');
const { ContentBox } = require('commonsComponents/contentBox');
const MorePulses = require('components/commons/broker/pulses/morePulses');
const { LoadingSection } = require('commonsComponents/loadingSection');
const { HTMLSafeInjector } = require('commonsComponents/htmlSafeInjector');
//@actions
const marketPulsesActions = require('actions/brokerMarketPulses');
const { DATE_FORMAT_ES, DATE_FORMAT_SHORT_TIME_24 } = require('constants/index');
const DateHelper = require('utilities/dateHelper');

class BrokerMarketsPulseDetailsView extends React.Component {
    buildContent() {
        const { match: { params: { pulseId } }, immMarketsPulses } = this.props;

        if (immMarketsPulses.get('isFetching')) {
            return <LoadingSection />;
        }

        const immPulse = immMarketsPulses.getIn(['byId', pulseId]);
        const objId = `brokerPulse_${immPulse.get('id')}`;
        const parsedDate = `${DateHelper.buildFormattedDate(
            immPulse.get('date'),
            DATE_FORMAT_ES
        )} - ${DateHelper.buildFormattedDate(immPulse.get('date'), DATE_FORMAT_SHORT_TIME_24)}`;

        return (
            <ContentBox
                id="brokerMarketPulsesList"
                customClassName="broker-markets-pulse-details-view__pulse"
            >
                <div key={objId} id={objId} className="broker-markets-pulse-details-view__pulse">
                    <h3>
                        {<HTMLSafeInjector inline message={immPulse.get('title')} />}
                    </h3>
                    <span className="broker-markets-pulse-details-view__separator" />
                    <div className="broker-markets-pulse-details-view__date">
                        {parsedDate}
                    </div>
                    <HTMLSafeInjector
                        customClass="pulses-container"
                        message={immPulse.get('inlet')}
                    />
                    <HTMLSafeInjector
                        customClass="pulses-container"
                        message={immPulse.get('body')}
                    />
                    <div className="pull-right">
                        <OKLink modifier="emphasize" to="myprofile/broker/news">
                            <FormattedText value="broker-goBackToPulses" />
                        </OKLink>
                    </div>
                </div>
            </ContentBox>
        );
    }

    render() {
        const { match: { params: { pulseId } }, immMarketsPulses, requestMarketPulses } = this.props;

        const immPulse = immMarketsPulses.getIn(['byId', pulseId]);
        if (typeof immPulse == 'undefined') {
            requestMarketPulses({
                start: 0,
                end: 20
            });
            return <div />;
        }
        const content = this.buildContent();

        const mappingBreadcrumb = [
            {
                text: formatText('breadcrumb-brokerInvestments'),
                url: '/myprofile/broker'
            },
            {
                text: formatText('breadcrumb-brokerMarkets'),
                url: '/myprofile/broker/news'
            },
            {
                text: formatText('breadcrumb-brokerPulses'),
                url: '/myprofile/broker/news'
            }
        ];
        // @hardcoded
        const titleColumnLeftText = formatText('broker-marketPulseDetailsTitle');

        return (
            <div className="broker-markets-pulse-details-view">
                <OKCover size="medium" section="broker">
                    <OKHeaderSubPage
                        breadcrumbConfig={mappingBreadcrumb}
                        finalTitle={getFinalTitle('breadcrumb-brokerPulses')}
                    />
                </OKCover>
                <section className="broker-markets-pulse-details-view__body">
                    <div className="col-lg-8">
                        <div className="row no-outside-gutter">
                            {content}
                        </div>
                    </div>
                    <div className="col-lg-4">
                        <ContentBox title={titleColumnLeftText} smallTitle={true}>
                            <MorePulses
                                immMarketsPulses={immMarketsPulses}
                                requestMarketPulses={requestMarketPulses}
                            />
                        </ContentBox>
                    </div>
                    <div className="col-lg-12 broker-markets-pulse-details-view__footer-disclaimer">
                        <div className="broker-markets-pulse-details-view__disclaimer-paragraph">
                            <FormattedText value="broker-disclaimerTextFirstParagraph" />
                        </div>
                        <div className="broker-markets-pulse-details-view__disclaimer-paragraph">
                            <FormattedText value="broker-disclaimerTextSecondParagraph" />
                        </div>
                    </div>
                </section>
            </div>
        );
    }
}

BrokerMarketsPulseDetailsView.propTypes = {
    immMarketsPulses: PropTypes.object,
    requestMarketPulses: PropTypes.func.isRequired,
    match: PropTypes.object.isRequired
};

module.exports.constructor = BrokerMarketsPulseDetailsView;
module.exports.BrokerMarketsPulseDetailsView = connect(
    state => ({
        immMarketsPulses: state.brokerMarketsPulses
    }),
    {
        requestMarketPulses: marketPulsesActions.requestMarketPulses
    }
)(BrokerMarketsPulseDetailsView);
